// extracted by mini-css-extract-plugin
export default {"navbar__container":"navigationBar_navbar__container__42nmj","navbar__button":"navigationBar_navbar__button__FBuR-","userIcon":"navigationBar_userIcon__Dg1Xw"};